import isNumber from 'lodash/isNumber';

import { getLocale } from '~/renderer/utils/config';

export const defaultCurrency = { code: 'USD', symbol: '$' };

interface CurrencyFormat {
  code: string;
  money: string;
}

export const applyCurrencyFormat = ({ code, money }: CurrencyFormat): string => {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, code ? { style: 'currency', currency: code } : {}).format(
    parseFloat(money),
  );
};

export const applyDecimalFormat = (number: string | number): string => {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, { style: 'decimal' }).format(
    isNumber(number) ? number : parseFloat(number),
  );
};
